import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AbilityQuery as AbilityQueryType, AbilityQueryVariables } from "./__generated__/AbilityQuery";

const AbilityQuery = loader("./AbilityQuery.gql");

type AbilityQueryProviderType = (props: {
  children: (data: AbilityQueryType) => ReactNode;
  variables: AbilityQueryVariables;
}) => ReactElement;

export const AbilityQueryProvider: AbilityQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<AbilityQueryType, AbilityQueryVariables>(AbilityQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
